import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import {
  CURRENT_OWNER_LABELS,
  WAITING_FOR_LABELS,
  type AuthorizationCase,
} from '@/services/authorization-case.service';
import { elapsedSince } from '../utils';

interface Props {
  kase: AuthorizationCase;
}

export function CaseStatusPanel({ kase }: Props) {
  return (
    <div className="rounded-xl border border-border bg-card p-5">
      <h3 className="mb-3 text-sm font-semibold text-foreground">Case Status</h3>
      <div className="space-y-2.5">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Current Owner</span>
          <span className="rounded-full bg-blue-500/10 px-2.5 py-1 text-xs font-medium text-blue-700">
            {CURRENT_OWNER_LABELS[kase.currentOwner]}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Waiting For</span>
          <span className="flex items-center gap-1.5 rounded-full bg-orange-500/10 px-2.5 py-1 text-xs font-medium text-orange-700">
            <FontAwesomeIcon icon={faClock} className="h-3 w-3" />
            {WAITING_FOR_LABELS[kase.waitingFor]} — {elapsedSince(kase.updatedAt)}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Priority</span>
          {kase.priorityName ? (
            <span
              className="rounded-full px-2.5 py-1 text-xs font-medium"
              style={{
                backgroundColor: `${kase.priorityColor}1A`,
                color: kase.priorityColor ?? undefined,
              }}
            >
              {kase.priorityName}
            </span>
          ) : (
            <span className="text-xs text-muted-foreground">Not set</span>
          )}
        </div>
      </div>
    </div>
  );
}
